export type ProcessingMode = 'TICKET_MANAGEMENT' | 'EMAIL' | 'CRM_API';

export const ProcessingMode = {
  TicketManagement: 'TICKET_MANAGEMENT' as ProcessingMode,
  Email: 'EMAIL' as ProcessingMode,
  CrmApi: 'CRM_API' as ProcessingMode
};
